<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Exporter une ligne du temps</p>
		</header>
		<section class="modal-card-body">
            <div style="min-height: 360px; padding: 30px; text-align: center;" v-if="!format">
                <div class="box" @click="create('PDF')">
                    <article class="media" style="display: flex; align-items: center;">
                        <figure class="media-left">
                            <p class="image is-96x96">
                                <svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m160.6 360.7h-10.6v47.6h10.6c5.2 0 9.3-1.8 12.4-5.3s4.6-8.1 4.6-13.6v-10c0-5.5-1.5-10-4.6-13.5-3-3.4-7.1-5.2-12.4-5.2z"/><path d="m103.1 360.7h-14v22.9h14.1c4 0 7-1.1 9.1-3.2 2-2.1 3-4.9 3-8.2s-1-6.1-3-8.3c-2.1-2.1-5.2-3.2-9.2-3.2z"/><path d="m257.7 384.5 65.6-57.4h-271.7v114.9h271.8zm-137.7 2.3c-4.1 3.7-9.7 5.5-16.9 5.5h-14v24.7h-10.9v-65h24.9c7.2 0 12.8 1.9 16.9 5.6s6.1 8.6 6.1 14.6c0 6.1-2.1 11-6.1 14.6zm68.5 2.6c0 8.1-2.6 14.7-7.7 19.9-5.2 5.1-11.9 7.7-20.1 7.7h-21.5v-65h21.5c8.2 0 14.9 2.6 20.1 7.7s7.7 11.8 7.7 19.9zm56.3-28.7h-30.8v19.9h26.2v8.7h-26.2v27.7h-10.8v-65h41.6z"/><path d="m455.8 117.2h-27.9v-54h-63.1v54h-27.8c-4 0-6.1 4.2-3.4 6.8l59.4 68.9c1.8 1.8 5 1.8 6.8 0l59.4-68.9c2.7-2.7.6-6.8-3.4-6.8z"/><path d="m364.8 28.9h63.1v24.5h-63.1z"/><path d="m389.5 206v259.4c0 15.1-12.2 27.3-27.3 27.3h-262.6c-15.1 0-27.3-12.2-27.3-27.3v-14.6h-13.4v20c0 19.5 15.8 35.4 35.4 35.4h273.2c19.5 0 35.4-15.8 35.4-35.4v-264.7c-2 .8-4.2 1.2-6.5 1.2-2.4 0-4.8-.5-6.9-1.3z"/><path d="m72.3 81.1c0-15.1 12.2-27.3 27.3-27.3h252.1v-3.8-9.5h-257.4c-19.5 0-35.4 15.8-35.4 35.4v242.5h13.4z"/><path d="m323.2 132h-210.9v19.4h227.7l-16.1-18.6c-.3-.2-.5-.5-.7-.8z"/><path d="m112.3 163.5h237.2v19.4h-237.2z"/><path d="m112.3 195h237.2v19.4h-237.2z"/><path d="m112.3 226.6h237.2v19.4h-237.2z"/><path d="m112.3 258.1h185.8v19.4h-185.8z"/><path d="m427.9 10.1c0-2.2-2-4.1-4.6-4.1h-54c-2.5 0-4.6 1.8-4.6 4.1v9h63.1v-9z"/></svg>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <p>Obtenir une version imprimable de la ligne du temps</p>
                            </div>
                        </div>    
                    </article>
                </div>
                <div class="box" @click="create('ZIP')">
                    <article class="media" style=" display: flex; align-items: center;">
                        <figure class="media-left">
                            <p class="image is-96x96">
                                <svg id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M199.1,362.5h-13v21.2h13c3.7,0,6.5-1,8.4-3c1.9-2,2.8-4.5,2.8-7.5c0-3-0.9-5.6-2.8-7.6   C205.5,363.5,202.8,362.5,199.1,362.5z" id="XMLID_15_"/><path d="M257.7,384.5l65.6-57.4H51.6v114.9h271.8L257.7,384.5z M137,414.5H94.8v-6.3l29.3-45.7H95v-8h40.9v6l-29.4,46H137V414.5z    M160.1,414.5h-10v-60h10V414.5z M214.6,386.7c-3.8,3.4-8.9,5.1-15.6,5.1h-13v22.7h-10v-60h23c6.6,0,11.8,1.7,15.6,5.1   c3.8,3.4,5.6,7.9,5.6,13.5C220.2,378.8,218.4,383.3,214.6,386.7z"/><path d="M455.8,117.2h-27.9v-54h-63.1v54H337c-4,0-6.1,4.2-3.4,6.8l59.4,68.9c1.8,1.8,5,1.8,6.8,0l59.4-68.9   C461.9,121.3,459.8,117.2,455.8,117.2z" id="XMLID_10_"/><rect height="24.5" id="XMLID_9_" width="63.1" x="364.8" y="28.9"/><path d="M389.5,206v259.4c0,15.1-12.2,27.3-27.3,27.3H99.6c-15.1,0-27.3-12.2-27.3-27.3v-14.6H58.9v20   c0,19.5,15.8,35.4,35.4,35.4h273.2c19.5,0,35.4-15.8,35.4-35.4V206.1c-2,0.8-4.2,1.2-6.5,1.2C394,207.3,391.6,206.8,389.5,206z" id="XMLID_8_"/><path d="M72.3,81.1c0-15.1,12.2-27.3,27.3-27.3h252.1V50v-9.5H94.3c-19.5,0-35.4,15.8-35.4,35.4v242.5h13.4V81.1z" id="XMLID_7_"/><path d="M323.2,132H112.3v19.4h227.7l-16.1-18.6C323.6,132.6,323.4,132.3,323.2,132z" id="XMLID_6_"/><rect height="19.4" id="XMLID_5_" width="237.2" x="112.3" y="163.5"/><rect height="19.4" id="XMLID_4_" width="237.2" x="112.3" y="195"/><rect height="19.4" id="XMLID_3_" width="237.2" x="112.3" y="226.6"/><rect height="19.4" id="XMLID_2_" width="185.8" x="112.3" y="258.1"/><path d="M427.9,10.1c0-2.2-2-4.1-4.6-4.1h-54c-2.5,0-4.6,1.8-4.6,4.1v9h63.1V10.1z" id="XMLID_1_"/></g></svg>
                            </p>
                        </figure>
                        <div class="media-content">
                            <div class="content">
                                <p>Télécharger un fichier zip contenant les données de votre ligne du temps et l'ensemble des documents multimédias</p>
                            </div>
                        </div>    
                    </article>
                </div>
            </div>

            <div style="min-height: 360px; padding: 30px; text-align: center;" v-if="format">

                <p>
                    <span v-if="!url">Génération du document en cours ...</span>
                    <span v-if="url">Votre document est disponible</span>
                </p>

                <div style="width: 100px; text-align: center; margin: 60px auto;">
                    <div v-if="format == 'ZIP'">
                        <svg id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M199.1,362.5h-13v21.2h13c3.7,0,6.5-1,8.4-3c1.9-2,2.8-4.5,2.8-7.5c0-3-0.9-5.6-2.8-7.6   C205.5,363.5,202.8,362.5,199.1,362.5z" id="XMLID_15_"/><path d="M257.7,384.5l65.6-57.4H51.6v114.9h271.8L257.7,384.5z M137,414.5H94.8v-6.3l29.3-45.7H95v-8h40.9v6l-29.4,46H137V414.5z    M160.1,414.5h-10v-60h10V414.5z M214.6,386.7c-3.8,3.4-8.9,5.1-15.6,5.1h-13v22.7h-10v-60h23c6.6,0,11.8,1.7,15.6,5.1   c3.8,3.4,5.6,7.9,5.6,13.5C220.2,378.8,218.4,383.3,214.6,386.7z"/><path d="M455.8,117.2h-27.9v-54h-63.1v54H337c-4,0-6.1,4.2-3.4,6.8l59.4,68.9c1.8,1.8,5,1.8,6.8,0l59.4-68.9   C461.9,121.3,459.8,117.2,455.8,117.2z" id="XMLID_10_"/><rect height="24.5" id="XMLID_9_" width="63.1" x="364.8" y="28.9"/><path d="M389.5,206v259.4c0,15.1-12.2,27.3-27.3,27.3H99.6c-15.1,0-27.3-12.2-27.3-27.3v-14.6H58.9v20   c0,19.5,15.8,35.4,35.4,35.4h273.2c19.5,0,35.4-15.8,35.4-35.4V206.1c-2,0.8-4.2,1.2-6.5,1.2C394,207.3,391.6,206.8,389.5,206z" id="XMLID_8_"/><path d="M72.3,81.1c0-15.1,12.2-27.3,27.3-27.3h252.1V50v-9.5H94.3c-19.5,0-35.4,15.8-35.4,35.4v242.5h13.4V81.1z" id="XMLID_7_"/><path d="M323.2,132H112.3v19.4h227.7l-16.1-18.6C323.6,132.6,323.4,132.3,323.2,132z" id="XMLID_6_"/><rect height="19.4" id="XMLID_5_" width="237.2" x="112.3" y="163.5"/><rect height="19.4" id="XMLID_4_" width="237.2" x="112.3" y="195"/><rect height="19.4" id="XMLID_3_" width="237.2" x="112.3" y="226.6"/><rect height="19.4" id="XMLID_2_" width="185.8" x="112.3" y="258.1"/><path d="M427.9,10.1c0-2.2-2-4.1-4.6-4.1h-54c-2.5,0-4.6,1.8-4.6,4.1v9h63.1V10.1z" id="XMLID_1_"/></g></svg>
                    </div>
                    <div v-if="format == 'PDF'">
                        <svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m160.6 360.7h-10.6v47.6h10.6c5.2 0 9.3-1.8 12.4-5.3s4.6-8.1 4.6-13.6v-10c0-5.5-1.5-10-4.6-13.5-3-3.4-7.1-5.2-12.4-5.2z"/><path d="m103.1 360.7h-14v22.9h14.1c4 0 7-1.1 9.1-3.2 2-2.1 3-4.9 3-8.2s-1-6.1-3-8.3c-2.1-2.1-5.2-3.2-9.2-3.2z"/><path d="m257.7 384.5 65.6-57.4h-271.7v114.9h271.8zm-137.7 2.3c-4.1 3.7-9.7 5.5-16.9 5.5h-14v24.7h-10.9v-65h24.9c7.2 0 12.8 1.9 16.9 5.6s6.1 8.6 6.1 14.6c0 6.1-2.1 11-6.1 14.6zm68.5 2.6c0 8.1-2.6 14.7-7.7 19.9-5.2 5.1-11.9 7.7-20.1 7.7h-21.5v-65h21.5c8.2 0 14.9 2.6 20.1 7.7s7.7 11.8 7.7 19.9zm56.3-28.7h-30.8v19.9h26.2v8.7h-26.2v27.7h-10.8v-65h41.6z"/><path d="m455.8 117.2h-27.9v-54h-63.1v54h-27.8c-4 0-6.1 4.2-3.4 6.8l59.4 68.9c1.8 1.8 5 1.8 6.8 0l59.4-68.9c2.7-2.7.6-6.8-3.4-6.8z"/><path d="m364.8 28.9h63.1v24.5h-63.1z"/><path d="m389.5 206v259.4c0 15.1-12.2 27.3-27.3 27.3h-262.6c-15.1 0-27.3-12.2-27.3-27.3v-14.6h-13.4v20c0 19.5 15.8 35.4 35.4 35.4h273.2c19.5 0 35.4-15.8 35.4-35.4v-264.7c-2 .8-4.2 1.2-6.5 1.2-2.4 0-4.8-.5-6.9-1.3z"/><path d="m72.3 81.1c0-15.1 12.2-27.3 27.3-27.3h252.1v-3.8-9.5h-257.4c-19.5 0-35.4 15.8-35.4 35.4v242.5h13.4z"/><path d="m323.2 132h-210.9v19.4h227.7l-16.1-18.6c-.3-.2-.5-.5-.7-.8z"/><path d="m112.3 163.5h237.2v19.4h-237.2z"/><path d="m112.3 195h237.2v19.4h-237.2z"/><path d="m112.3 226.6h237.2v19.4h-237.2z"/><path d="m112.3 258.1h185.8v19.4h-185.8z"/><path d="m427.9 10.1c0-2.2-2-4.1-4.6-4.1h-54c-2.5 0-4.6 1.8-4.6 4.1v9h63.1v-9z"/></svg>
                    </div>
                </div>

                <a :href="url" download class="button is-primary" v-if="url">
                    Télécharger le document
                </a>

                <b-loading :is-full-page="false" :active.sync="inProgress"></b-loading>
            </div>
		</section>
		<!--<footer class="modal-card-foot">
            <div class="field">
                <div class="control">
                    <button class="button is-primary" @click="submit()" :disabled="form.processing">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Exporter</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
        
            </div>
        </footer>
        -->
	</div>
</template>

<script>

export default {
    props: ['timeline'],

    data() {
        return {
            inProgress: false,
            url: '',
            timer: null,
            job_status_url: '',
            format: null,
        }
        
    },
    
    methods: {

        create(format) {

            this.format = format;
            this.inProgress = true;

            axios.post('/api/v1/timelines/' + this.timeline.id + '/export', {
                format: this.format
            }).then( response => {

                    if (response.status == 202) {
                        this.job_status_url = response.headers.location;
                        this.timer = setInterval(() => {this.retrieve()}, 1000);
                    }

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });

                this.$parent.close()
            });
        },

        retrieve() {
            console.log('retrieve...');

            axios.get(this.job_status_url)
                 .then( response1 => {
            
                    if (response1.data.job.status == 'finished') {
                        this.inProgress = false;
                        this.url = response1.data.job.result.url;
                        clearInterval(this.timer);
                    }
                }).catch( error => {
                    clearInterval(this.timer);
                    console.log(error);
                    
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });

                    this.$parent.close();

                });
        }
    },

}
</script>

<style>
</style>
